<template lang="pug">
v-hover(v-slot="{ hover }")
  v-card(
    :elevation="hover ? 2 : 0"
    ripple
    @click="$emit('setTheme', theme.id)"
    color="grey lighten-4"
    class="tw-bg-gray-lighten-4 tw-cursor-pointer tw-py-10 tw-items-start"
  )
    div
      v-img(
        :src="require('@/assets/images/websites/' + theme.path + '.png')"
        max-width="450px"
        contain
        class="mx-auto tw-border tw-rounded-md tw-overflow-hidden tw-border-gray-lighten-2"
      )
    div(class="tw-px-10 tw-text-center tw-pt-8 tw-text-lg tw-font-semibold")
      span(class="tw-capitalize") {{ theme.name }}
</template>
<script>
export default {
  props: {
    theme: {
      type: Object,
      default: null,
    },
  },
};
</script>
